// Mock data for Hudson Knox Outdoor Living website

export const mockTestimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "Kensington, London",
    rating: 5,
    text: "Hudson Knox transformed our garden into a year-round living space. The motorised pergola is absolutely stunning and the installation was flawless.",
    project: "Motorised Louvered Pergola"
  },
  {
    id: 2,
    name: "James Porter",
    location: "Sevenoaks, Kent",
    rating: 5,
    text: "Exceptional craftsmanship and attention to detail. Our glass veranda has completely changed how we use our outdoor space.",
    project: "Glass Veranda Installation"
  },
  {
    id: 3,
    name: "Emma Richardson",
    location: "Greenwich, London",
    rating: 5,
    text: "Professional service from start to finish. The pergola blinds provide perfect shade and privacy. Highly recommend.",
    project: "Pergola with Zip Screens"
  }
];

export const mockProjects = [
  {
    id: 1,
    title: "Deponti Glass Veranda",
    location: "Chelsea, London",
    category: "Glass Veranda",
    description: "Deponti glass veranda with sliding doors, wooden decking and seamless indoor-outdoor living integration.",
    image: "https://customer-assets.emergentagent.com/job_luxury-pergolas/artifacts/u273tkcu_image001.png",
    features: ["Glass sliding doors", "Aluminium frame", "Wooden deck integration", "Modern design"]
  },
  {
    id: 2,
    title: "Glass Roof Pergola with Lounge",
    location: "Tunbridge Wells, Kent",
    category: "Glass Veranda",
    description: "Deponti glass roof veranda with comfortable lounge seating and panoramic garden views.",
    image: "https://customer-assets.emergentagent.com/job_luxury-pergolas/artifacts/2wc2g5nn_image006.png",
    features: ["Glass roof panels", "Lounge area", "Garden views", "Aluminium construction"]
  },
  {
    id: 3,
    title: "Contemporary Glass Walls",
    location: "Richmond, London",
    category: "Glass Veranda",
    description: "Deponti veranda with frameless glass sliding walls providing unobstructed garden views and weather protection.",
    image: "https://customer-assets.emergentagent.com/job_luxury-pergolas/artifacts/z8odfgv9_image003.png",
    features: ["Glass sliding walls", "Lounge area", "Waterside view", "Aluminium construction"]
  },
  {
    id: 4,
    title: "Modern Pergola with Privacy Wall",
    location: "Bromley, Kent",
    category: "Pergola Installation",
    description: "Deponti anthracite pergola with integrated privacy wall and contemporary outdoor dining setup.",
    image: "https://customer-assets.emergentagent.com/job_luxury-pergolas/artifacts/omcz2dp3_image007.png",
    features: ["Privacy wall", "Anthracite finish", "Outdoor dining", "Modern design"]
  },
  {
    id: 5,
    title: "Glass Roof Dining Pergola",
    location: "Dulwich, London",
    category: "Glass Veranda",
    description: "Deponti glass roof pergola perfect for outdoor dining with glass sliding panels and garden access.",
    image: "https://customer-assets.emergentagent.com/job_luxury-pergolas/artifacts/4xysqz7b_image008.png",
    features: ["Glass roof system", "Sliding panels", "Dining area", "Garden integration"]
  },
  {
    id: 6,
    title: "Louvered Roof System",
    location: "Maidstone, Kent",
    category: "Motorised Pergola",
    description: "Deponti premium louvered pergola with integrated LED lighting and motorised roof control.",
    image: "https://customer-assets.emergentagent.com/job_luxury-pergolas/artifacts/6bdk9mb9_image005.png",
    features: ["Motorised louvered roof", "LED lighting", "Aluminium frame", "Smart controls"]
  },
  {
    id: 7,
    title: "Glass Roof Pergola System",
    location: "Guildford, Surrey",
    category: "Glass Veranda",
    description: "Premium Deponti glass roof pergola with outdoor dining setup and glass roof panels.",
    image: "https://customer-assets.emergentagent.com/job_luxury-pergolas/artifacts/dh3om5yt_image002.png",
    features: ["Glass roof", "Outdoor dining", "Weather protection", "Premium aluminium"]
  },
  {
    id: 8,
    title: "Louvered Pergola with Dining",
    location: "Sevenoaks, Kent",
    category: "Motorised Pergola",
    description: "Deponti louvered roof system with adjustable panels for complete sun and shade control.",
    image: "https://customer-assets.emergentagent.com/job_luxury-pergolas/artifacts/daomcqrb_image004.png",
    features: ["Louvered roof", "Adjustable panels", "Garden dining", "Weather control"]
  }
];

export const mockServices = [
  {
    id: 1,
    title: "Aluminium Pergola Installation",
    slug: "pergola-installation",
    shortDescription: "Premium Deponti aluminium pergolas and modern metal structures",
    icon: "Home",
    featured: true
  },
  {
    id: 2,
    title: "Motorised Louvered Pergolas",
    slug: "motorised-pergolas",
    shortDescription: "Smart aluminium pergolas with adjustable roofs and weather control",
    icon: "Settings",
    featured: true
  },
  {
    id: 3,
    title: "Pergola Blinds & Zip Screens",
    slug: "pergola-blinds",
    shortDescription: "Privacy, shade and wind protection for outdoor spaces",
    icon: "ShieldCheck",
    featured: true
  },
  {
    id: 4,
    title: "Glass Verandas",
    slug: "glass-verandas",
    shortDescription: "Extend your living space with elegant aluminium & glass structures",
    icon: "Frame",
    featured: true
  },
  {
    id: 5,
    title: "Rooflight & Skylight Blinds",
    slug: "rooflight-blinds",
    shortDescription: "Custom motorised blinds for roof lanterns",
    icon: "Sun",
    featured: false
  },
  {
    id: 6,
    title: "Plantation Shutters",
    slug: "plantation-shutters",
    shortDescription: "Interior light-control and privacy solutions",
    icon: "Blinds",
    featured: false
  }
];

export const mockLocations = [
  {
    name: "London",
    areas: ["Kensington", "Chelsea", "Richmond", "Greenwich", "Dulwich", "Hampstead", "Wimbledon", "Fulham", "Blackheath", "Clapham"]
  },
  {
    name: "Kent",
    areas: ["Sevenoaks", "Tunbridge Wells", "Bromley", "Maidstone", "Canterbury", "Ashford", "Tonbridge", "Dartford"]
  },
  {
    name: "Surrey",
    areas: ["Guildford", "Woking", "Reigate", "Epsom", "Leatherhead", "Weybridge", "Esher", "Cobham"]
  },
  {
    name: "Sussex",
    areas: ["Brighton", "Hove", "Worthing", "Crawley", "Horsham", "Chichester", "Eastbourne", "Lewes"]
  },
  {
    name: "Berkshire",
    areas: ["Windsor", "Reading", "Maidenhead", "Bracknell", "Wokingham", "Ascot", "Slough"]
  },
  {
    name: "Hampshire",
    areas: ["Winchester", "Southampton", "Basingstoke", "Farnborough", "Aldershot", "Andover"]
  },
  {
    name: "Essex",
    areas: ["Chelmsford", "Colchester", "Southend-on-Sea", "Basildon", "Brentwood", "Harlow"]
  }
];

export const mockFormSubmissions = [];

export const submitQuoteForm = (formData) => {
  const submission = {
    id: Date.now(),
    ...formData,
    submittedAt: new Date().toISOString(),
    status: "pending"
  };
  mockFormSubmissions.push(submission);
  return submission;
};
